import { useEffect, useRef } from "react";

// src/kiosk/useIdleReset.js
export function useIdleReset(onIdle, ms = 45000, enabled = true) {
  const timer = useRef();
  useEffect(() => {
    if (!enabled) return;
    const bump = () => {
      clearTimeout(timer.current);
      timer.current = setTimeout(onIdle, ms);
    };
    bump();
    const events = ['pointerdown', 'keydown', 'touchstart'];
    events.forEach(e => window.addEventListener(e, bump, { passive: true }));
    return () => {
      clearTimeout(timer.current);
      events.forEach(e => window.removeEventListener(e, bump));
    };
  }, [onIdle, ms, enabled]);
}